import request from './request'

//注册
export function register(params) {
    return request({
        url: '/app-api/fdi/member/register',
        method: 'post',
        data: params
    })
}

//账号是否存在
export function isExsitAccount(params) {
    return request({
        url: `/app-api/fdi/member/isExsitAccount?accountName=${params}`,
        method: 'post'
    })
}

//账号密码登录
export function login(params) {
    return request({
        url: '/app-api/fdi/member/login',
        method: 'post',
        data: params
    })
}

//更改个人密码
export function updatePsw(params) {
    return request({
        url: '/app-api/fdi/member/updatePwd',
        method: 'post',
        data: params
    })
}

//获取个人信息
export function getMyInfo() {
    return request({
        url: '/app-api/fdi/member/MyInfo',
        method: 'get',
    })
}

//更新个人信息
export function updateGrInfo(params) {
    return request({
        url: '/app-api/fdi/member/updateInfo',
        method: 'post',
        data: params
    })
}

//获取地区
export function getArea() {
    return request({
        url: '/app-api/fdi/area/tree',
        method: 'get',
    })
}

//获取字典
export function getSimple() {
    return request({
        url: '/app-api/fdi/dict/simple-list-tree',
        method: 'get',
    })
}

//上传文件 
export function uploadFile(params) {
    return request({
        url: '/app-api/fdi/file/upload',
        method: 'post',
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        data: params
    })
}
//任务书项目列表分页
export function taskProjectList(params) {
    return request({
        url: '/app-api/fdi/assignment-info/myProjectList',
        method: 'post',
        data: params
    })
}
//新增任务书项目
export function addTaskProject(params) {
    return request({
        url: '/app-api/fdi/assignment-info/create',
        method: 'post',
        data: params
    })
}
//编辑任务书项目
export function editTaskProject(params) {
    return request({
        url: '/app-api/fdi/assignment-info/update',
        method: 'post',
        data: params
    })
}
//删除任务书项目
export function deleteTaskProject(params) {
    return request({
        url: '/app-api/fdi/project-info/deleteProject',
        method: 'post',
        data: params
    })
}

export function detailTaskProject(params) {
    return request({
        url: '/app-api/fdi/assignment-info/detial?infoId=' + params,
        method: 'get',
        data: params
    })
}

//创建项目
export function createProjectInfo(params) {
    return request({
        url: '/app-api/fdi/project-info/create',
        method: 'post',
        data: params
    })
}

//我的项目列表分页
export function getMyProjectList(params) {
    return request({
        url: '/app-api/fdi/project-info/myProjectList',
        method: 'post',
        data: params
    })
}

//项目详情
export function getMyProjectDetail(params) {
    return request({
        url: '/app-api/fdi/project-info/detial?infoId=' + params,
        method: 'get'
    })
}

//项目发布
export function releaseProject(params) {
    return request({
        url: '/app-api/fdi/project-info/release',
        method: 'post',
        data: params
    })

}
//项目编辑
export function updateProject(params) {
    return request({
        url: '/app-api/fdi/project-info/update',
        method: 'post',
        data: params
    })

}

//删除项目
export function delProject(params) {
    return request({
        url: '/app-api/fdi/project-info/deleteProject',
        method: 'post',
        data: params
    })
}


//申请参与项目 
export function involvedProject(params) {
    return request({
        url: '/app-api/fdi/project-info/involved',
        method: 'post',
        data: params
    })

}

//我的参与项目列表分页
export function getMyInvolvedPageList(params) {
    return request({
        url: '/app-api/fdi/project-info/myInvolvedPage',
        method: 'post',
        data: params
    })
}

//审核参与项目的申请
export function auditInvolvedApply(params) {
    return request({
        url: '/app-api/fdi/project-info/auditInvolvedApply',
        method: 'post',
        data: params
    })
}

//取消参与项目
export function cancelInvolve(params) {
    return request({
        url: '/app-api/fdi/project-info/cancelInvolve',
        method: 'post',
        data: params
    })
}

//我的待审核的参与列表-分页
export function getMyToAuditInvolvedPage(params) {
    return request({
        url: '/app-api/fdi/project-info/myToAuditInvolvedPage',
        method: 'post',
        data: params
    })
}

//我的审核过或待审核的参与列表-分页
export function getMyAuditInvolvedPage(params) {
    return request({
        url: '/app-api/fdi/project-info/myAuditInvolvedPage',
        method: 'post',
        data: params
    })
}

//收藏项目 
export function collectProject(params) {
    return request({
        url: '/app-api/fdi/project-info/collection',
        method: 'post',
        data: params
    })

}

//取消收藏项目 
export function delCollectProject(params) {
    return request({
        url: '/app-api/fdi/project-info/delCollection',
        method: 'post',
        data: params
    })

}

//我的收藏项目列表分页
export function getMyCollectionProjectList(params) {
    return request({
        url: '/app-api/fdi/project-info/myCollectionPage',
        method: 'post',
        data: params
    })
}

//我的评论列表分页
export function getMyCommentPageList(params) {
    return request({
        url: '/app-api/fdi/project-info/myCommentPage',
        method: 'post',
        data: params
    })
}

//产品手册
//创建
export function createMyProduct(params) {
    return request({
        url: '/app-api/fdi/product/create',
        method: 'post',
        data: params
    })
}
//获取列表
export function getMyProduct(params) {
    return request({
        url: '/app-api/fdi/product/myProduct',
        method: 'post',
        data: params
    })
}
//修改
export function updateMyProduct(params) {
    return request({
        url: '/app-api/fdi/product/update',
        method: 'post',
        data: params
    })
}
//删除
export function deleteMyProduct(params) {
    return request({
        url: '/app-api/fdi/product/delete?id=' + params,
        method: 'get',
    })
}

//首页数据
export function getHomePage() {
    return request({
        url: '/app-api/fdi/homepage/index',
        method: 'get'
    })
}


//设计师分页与搜索
export function getDesigner(params) {
    return request({
        url: '/app-api/fdi/homepage/search/designer',
        method: 'post',
        data: params
    })
}

export function getDesignerList(params) {
    return request({
        url: '/app-api/fdi/homepage/search/user-in-project',
        method: 'post',
        data: params
    })
}

//设计师主页（详情页）
export function getUserhome(params) {
    return request({
        url: '/app-api/fdi/homepage/userhome',
        method: 'post',
        data: params
    })
}
//设计详情页中的项目分页
export function getUPro(params) {
    return request({
        url: '/app-api/fdi/homepage/userhome/projectlist',
        method: 'post',
        data: params
    })
}
//设计详情页中的参与项目分页
export function getUINPro(params) {
    return request({
        url: '/app-api/fdi/homepage/userhome/involvedprojectlist',
        method: 'post',
        data: params
    })
}

//搜索-精品项目
export function getProjectJingpin(params) {
    return request({
        url: '/app-api/fdi/homepage/search/project-jingpin',
        method: 'post',
        data: params
    })
}

//精选案例分页与搜索 成功
export function getCaseJingxuan(params) {
    return request({
        url: '/app-api/fdi/homepage/search/case-jingxuan',
        method: 'post',
        data: params
    })
}
//推荐案例分页与搜索 
export function getCaseTuijian(params) {
    return request({
        url: '/app-api/fdi/homepage/search/case-tuijian',
        method: 'post',
        data: params
    })
}
//专业服务分页与搜索
export function getService(params) {
    return request({
        url: '/app-api/fdi/homepage/search/service',
        method: 'post',
        data: params
    })
}
//资源共享分页与搜索
export function getResourceshare(params) {
    return request({
        url: '/app-api/fdi/homepage/search/resourceshare',
        method: 'post',
        data: params
    })
}

//新闻分页与搜索
export function getNewsList(params) {
    return request({
        url: '/app-api/fdi/homepage/search/news',
        method: 'post',
        data: params
    })
}
//新闻详情
export function getNewsDetail(params) {
    return request({
        url: '/app-api/fdi/homepage/news/detial?infoId=' + params,
        method: 'get'
    })
}


//业界访谈分页与搜索
export function getInterview(params) {
    return request({
        url: '/app-api/fdi/homepage/interview',
        method: 'post',
        data: params
    })
}

//系统信息
export function getInfoByKeys(params) {
    return request({
        url: '/app-api/fdi/sysinfo/getInfoByKeys',
        method: 'get',
        data: params
    })
}

//我的系统消息
export function getMySysteamNotice(params) {
    return request({
        url: '/app-api/fdi/message/mySysteamNotice',
        method: 'post',
        data: params
    })
}

//私信与回复
export function createMessage(params) {
    return request({
        url: '/app-api/fdi/message/create',
        method: 'post',
        data: params
    })
}

//获取私信列表
export function getMyLetter(params) {
    return request({
        url: '/app-api/fdi/message/myLetter',
        method: 'post',
        data: params
    })
}

//消息设置为已读
export function messageRead(params) {
    return request({
        url: '/app-api/fdi/message/read?messageId=' + params,
        method: 'get'
    })
}
//系统消息设置为已读
export function sysMessageRead(params) {
    return request({
        url: '/app-api/fdi/message/mySysteamNotice/update-read?ids=' + params,
        method: 'get'
    })
}

//添加评论
export function addComment(params) {
    return request({
        url: '/app-api/fdi/project-info/addComment',
        method: 'post',
        data: params
    })
}

//项目详情中更多评论
export function moreComment(params) {
    return request({
        url: '/app-api/fdi/project-info/detail/moreComment',
        method: 'post',
        data: params
    })
}

//公司主页
export function getCompany(params) {
    return request({
        url: '/app-api/fdi/homepage/home/company?id=' + params,
        method: 'get',
    })
}

//公司主页-项目列表分页 
export function getCompanyProjectList(params) {
    return request({
        url: '/app-api/fdi/homepage/home/company/projectList',
        method: 'post',
        data: params
    })
}

//公司主页-产品列表分页
export function getCompanyProduct(params) {
    return request({
        url: '/app-api/fdi/homepage/home/company/product',
        method: 'post',
        data: params
    })
}

//公司主页-参与的项目列表分页
export function getCompanyInvolvedPage(params) {
    return request({
        url: '/app-api/fdi/homepage/home/company/involvedPage',
        method: 'post',
        data: params
    })
}

//资源共享下的项目详情
export function getResourceshareDetial(params) {
    return request({
        url: '/app-api/fdi/homepage/resourceshare/detial?infoId='+params,
        method: 'get'
    })
}

//回访信息
export function getCasesBackInfo(params) {
    return request({
        url: '/app-api/fdi/project-info/review/list',
        method: 'post',
        data: params
    })
}
